// extracted by mini-css-extract-plugin
module.exports = {"contact":"ButtonConsult-module--contact--3iadS","contact_icon":"ButtonConsult-module--contact_icon--3_u3v"};